/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryActivityLogResponse } from './RevisdomAPIViewModelsEntryActivityLogResponse';
import {
    RevisdomAPIViewModelsEntryActivityLogResponseFromJSON,
    RevisdomAPIViewModelsEntryActivityLogResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryActivityLogResponseToJSON,
    RevisdomAPIViewModelsEntryActivityLogResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryActivityLogResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryActivityLogListResponse
 */
export interface RevisdomAPIViewModelsEntryActivityLogListResponse {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryActivityLogResponse>}
     * @memberof RevisdomAPIViewModelsEntryActivityLogListResponse
     */
    items?: Array<RevisdomAPIViewModelsEntryActivityLogResponse> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryActivityLogListResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryActivityLogListResponse(value: object): value is RevisdomAPIViewModelsEntryActivityLogListResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryActivityLogListResponseFromJSON(json: any): RevisdomAPIViewModelsEntryActivityLogListResponse {
    return RevisdomAPIViewModelsEntryActivityLogListResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryActivityLogListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryActivityLogListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(RevisdomAPIViewModelsEntryActivityLogResponseFromJSON)),
    };
}

export function RevisdomAPIViewModelsEntryActivityLogListResponseToJSON(json: any): RevisdomAPIViewModelsEntryActivityLogListResponse {
    return RevisdomAPIViewModelsEntryActivityLogListResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryActivityLogListResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryActivityLogListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(RevisdomAPIViewModelsEntryActivityLogResponseToJSON)),
    };
}

